import { NgModule } from '@angular/core';
import { DashboardComponent } from './dashboard.component';
import { PatientMoveDialogComponent } from './patient-move-dialog/patient-move-dialog.component';
import { AuthGuard } from '../auth/auth-guard.service';
import {DatePipe} from '@angular/common';
import { RemarksComponent } from './remarks/remarks.component';
import { DialationStartsComponent } from './dialation-starts/dialation-starts.component';
import { FinishDilationComponent } from './finish-dilation/finish-dilation.component';
import { RemoveDilationComponent } from './remove-dilation/remove-dilation.component';
import { ConfirmationBoxComponent } from './confirmation-box/confirmation-box.component';
import { ChangecategoriesComponent } from './changecategories/changecategories.component';
import { ChangeremarkComponent } from './changeremark/changeremark.component';
import { WaitingReasonComponent } from './WaitingReason/WaitingReason.component';
import {SharedModule} from '../shared/shared.module';
import {DragDropModule} from '@angular/cdk/drag-drop';
import { ChartsModule } from 'ng2-charts';
import { GuidedTourModule, GuidedTourService } from "ngx-guided-tour";
import { UpgradeComponent } from 'app/upgrade/upgrade.component';
import { DashboardRoutingModule } from './dashboard-routes.module';
  

@NgModule({
declarations:[
    DashboardComponent,
    PatientMoveDialogComponent,
    RemarksComponent,
    DialationStartsComponent,
    FinishDilationComponent,
    RemoveDilationComponent,
    ConfirmationBoxComponent,
    ChangecategoriesComponent,
    ChangeremarkComponent,
    WaitingReasonComponent,
    UpgradeComponent
],
imports: [
    SharedModule,
    DashboardRoutingModule,
    // CommonModule,
    // MaterialModule, 
    // FormsModule,
    // ReactiveFormsModule,
    // BrowserAnimationsModule,
    //Ng2SearchPipeModule,
   // NgxPaginationModule,
    DragDropModule,
    GuidedTourModule,
    ChartsModule,
],
providers: [AuthGuard,DatePipe, GuidedTourService
    ],

entryComponents: [
    PatientMoveDialogComponent,RemarksComponent, DialationStartsComponent, FinishDilationComponent,
    RemoveDilationComponent,ConfirmationBoxComponent,ChangecategoriesComponent,ChangeremarkComponent,WaitingReasonComponent
]
})
export class DashboardModule {


}